import { toast } from "react-toastify";

const ShowError = () => {
  return toast.error("please fill all field after press next button");
};

export default ShowError;
